import Cookies from 'js-cookie';
import {Search} from '@material-ui/icons';
import {Language} from '../../../context/LanguageContext';
import {useCallback, useEffect, useState} from 'react';
import {useArea} from '../../../hooks';

export default function FormMapSearch({data, onClose}) {
  const tokens_session = Cookies.get('token');
  const {language, newObj} = Language();
  const [search, setSearch] = useState('');
  const [locationsList, setLocationList] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);
  const {searchDigitalMapping} = useArea();
  const handleSubmit = async () => {
    const response = await searchDigitalMapping(tokens_session, {q: search});
    setLocationList(response.data.data || []);
  };
  const handleOnClick = useCallback(
    async (item) => {
      switch (item.type) {
        case 'kawasan':
          await data.setPkCode(item.kode);
          data.mapRef.current.flyTo([item.latitude, item.longitude], 12);
          break;
        case 'projek':
          const onMoveEnd = () => {
            data.getMapData(
              data.mapRef.current.getBounds(),
              15,
              data.mapRef.current.getBounds().getCenter(),
              item.kodeTop
            );
            data.mapRef.current.off('moveend', onMoveEnd);
          };
          await data.mapRef.current.flyTo([item.latitude, item.longitude], 17);
          await data.setPkCode(item.kodeTop);
          await data.setProjectCode(item.kode);
          await data.getMapData(
            data.mapRef.current.getBounds(),
            13,
            data.mapRef.current.getBounds().getCenter(),
            item.kodeTop
          );
          data.mapRef.current.on('moveend', onMoveEnd);
          break;
        default:
          break;
      }
      onClose();
    },
    [data]
  );

  useEffect(() => {
    if (search.length >= 3) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const newTimeoutId = setTimeout(() => {
        handleSubmit();
      }, 750);
      setTimeoutId(newTimeoutId);
    } else if (search.length === 0) {
      setLocationList([]);
    }
    return () => clearTimeout(timeoutId);
  }, [search]);
  return (
    <div className='modal_content center map_search'>
      <div className='modal_body'>
        <form
          action='POST'
          className='map_search_form'
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className='map_search_input'>
            <input
              type='text'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Search className='map_search_icon' />
          </div>
        </form>

        <div className='map_search_list'>
          {locationsList.length > 0 ? (
            <>
              {locationsList.map((item) => (
                <div
                  className='map_search_item'
                  onClick={() => handleOnClick(item)}
                >
                  <p>{item.nama}</p>
                  <p>{item.kode}</p>
                </div>
              ))}
            </>
          ) : (
            <div className='map_search_empty'>
              <Search className='map_search_empty_icon' />
              <p className='map_search_empty_text'>
                You have the flexibility to search the location by inputting
                alphabet characters, numbers, or GPS coordinates.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
